;(function ($) {
    'use strict'

  const API_BASE = document.querySelector(
    'link[rel="https://api.w.org/"]',
  ).href;

  
    // DOM ready
    $(function () {
        // Set up Leaflet map
        const map = document.getElementById("map");
        if (map) {
          setupLeafletMap(map);
        }

        // Scroll-triggered slide-in animation for Gutenberg block columns
        // Each column is observed individually so that on mobile (stacked layout)
        // every column animates only when it itself enters the viewport.
        // Columns inside a nested .wp-block-columns (i.e. whose parent row is itself
        // inside a .wp-block-column) are also animated.
        if ('IntersectionObserver' in window) {
            const columns = Array.from(
                document.querySelectorAll('.wp-block-columns > .wp-block-column')
          );

            // Pre-set the stagger index based on sibling position so the CSS
            // delay still works on desktop where columns share the same row.
            columns.forEach((col) => {
                const siblings = Array.from(col.parentElement.children).filter(
                    (el) => el.classList.contains('wp-block-column')
                );
                col.style.setProperty('--col-index', siblings.indexOf(col));
            });

            const colObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add('is-visible');
                    colObserver.unobserve(entry.target);
                });
            }, { threshold: 0.1 });

            columns.forEach((col) => colObserver.observe(col));
        } else {
            // Fallback: make all columns visible immediately
            Array.from(
                document.querySelectorAll('.wp-block-columns > .wp-block-column')
            ).forEach((col) => col.classList.add('is-visible'));
        }
    })



  /**
   * Get posts data from the WordPress REST API
   * @param {string} slug - The post type slug
   * @param {number} perPage - The number of posts to retrieve
   * @returns {Promise<object[]>} - An array of post objects
   */
  async function fetchPosts(slug, perPage) {
    const response = await fetch(
      `${API_BASE}wp/v2/${slug}?per_page=${perPage}`,
    );

    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }

    const data = await response.json();
    return data;
  }

  /**
   * Set up Leaflet map
   * @param {HTMLElement} el - The map element
   */
  function setupLeafletMap(el) {
    const postSlug = el.dataset.mapId;
    const postsPerPage = 100;

    const mapOptions = {
      center: [41.389, 2.113],
      zoom: 9,
    };

    const map = L.map(el, mapOptions);

     const customIcon = L.icon({
         iconUrl: siteurl+"/wp-content/themes/upcgaudeix/img/icon-map.png",
         iconSize: [50, 50], // set the size of the icon
         iconAnchor: [25, 50], // set the anchor point of the icon
     });
     L.Marker.prototype.options.icon = customIcon;


    /**
     * Create markers on the Leaflet map
     * @param {object[]} posts - An array of post objects
     */
    const createMarkers = (posts) => {
      if (!posts || !posts.length) {
        console.warn("No markers found.", posts);
        return;
      }


      posts.forEach((post) => {
        const id = post.id;
        const { coordinates: { latitude, longitude } = {} } = post.acf;

        if (latitude && longitude) {
          const marker = L.marker([latitude, longitude]);
          markers.addLayer(marker);

          marker.on("click", (event) => {
            $(`.espais-patrimoni`).offcanvas("hide");
            $(`#offcanvas-${id}`).offcanvas("toggle");
          });
        }
      });

      map.addLayer(markers);
    };

    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      {
        attribution:
          '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: "abcd",
        minZoom: 8,
        maxZoom: 20,
      },
    ).addTo(map);

    // Create a marker cluster group
    const markers = L.markerClusterGroup({ singleMarkerMode: true});




    // Get the markers from the WP REST API and add them to the map
    fetchPosts(postSlug, postsPerPage).then(createMarkers);
  }





})(jQuery)
